module.exports = __webpack_public_path__ + "img/public/SiteIcons/searchIcon.svg?ed512f0a";